export interface PublicMutationErrorDetails {
  correlationId?: string;
  errorCode?: string;
  message: string;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isNonEmptyString = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;

/**
 * Extracts the public error payload shape returned by the admin API.
 */
export const extractPublicMutationError = (
  error: unknown,
  fallbackMessage: string,
): PublicMutationErrorDetails => {
  if (!isRecord(error)) {
    return { message: fallbackMessage };
  }

  if (
    isNonEmptyString(error.message) &&
    isNonEmptyString(error.code) &&
    isNonEmptyString(error.correlationId)
  ) {
    return {
      message: error.message,
      errorCode: error.code,
      correlationId: error.correlationId,
    };
  }

  const response = isRecord(error.response) ? error.response : null;
  const data = response && isRecord(response.data) ? response.data : null;

  if (
    data &&
    isNonEmptyString(data.message) &&
    isNonEmptyString(data.errorCode) &&
    isNonEmptyString(data.correlationId)
  ) {
    return {
      message: data.message,
      errorCode: data.errorCode,
      correlationId: data.correlationId,
    };
  }

  return { message: fallbackMessage };
};
